<template>
  <div
    :class="{'hide-for-print' : messages.length === 0}"
    class="pega-preview"
    data-test="outer-div"
  >
    <div class="boss-layout-block-large hide-for-print">
      <accordion
        :is-open="true"
      >
        <template #head>
          メッセージ作成
        </template>
        <template #body>
          <div
            v-if="!isRecipientsEmpty"
            class="boss-layout-block-large"
            data-test="create-message-box"
          >
            <dl class="boss-scout-send-wrap boss-layout-block-large">
              <dt class="boss-scout-send-left">
                宛先(TO)
              </dt>
              <dd class="boss-scout-send-right">
                <div
                  v-for="(to, index) in recipient.to"
                  :key="index"
                  :data-test="`to-${index}`"
                >
                  <label class="pega-input display-inline">
                    <input
                      v-model="to.checked"
                      type="checkbox"
                      data-test="to-checked"
                    > <span data-test="name">{{ to.name }}</span>
                    <span
                      data-test="email"
                      class="pega-recipients-label"
                    >（{{ to.email }}）</span>
                  </label>
                </div>
              </dd>
              <dt
                v-if="!isRecipientsCcEmpty"
                class="boss-scout-send-left"
                data-test="cc-area"
              >
                宛先(CC)
              </dt>
              <dd
                v-if="!isRecipientsCcEmpty"
                class="boss-scout-send-right"
              >
                <div
                  v-for="(cc, i) in recipient.cc"
                  :key="i"
                  :data-test="`cc-${i}`"
                >
                  <label class="pega-input display-inline">
                    <input
                      v-model="cc.checked"
                      type="checkbox"
                      data-test="cc-checked"
                    > <span data-test="name">{{ cc.name }}</span>
                    <span
                      data-test="email"
                      class="pega-recipients-label"
                    >（{{ cc.email }}）</span>
                  </label>
                  <button
                    v-if="isNotificationUser(cc.categoryId) && !isCompanyStaff"
                    :disabled="cc.checked"
                    class="boss-icon-trash"
                    data-test="delete-icon"
                    @click="deleteNotificationAccount(cc.id)"
                  />
                </div>
                <template v-if="!isCompanyStaff">
                  <input
                    v-model="name"
                    type="text"
                    class="boss-input pega-height-35"
                    data-test="input-name"
                    size="30"
                    placeholder="名前"
                  >
                  <input
                    v-model="email"
                    type="text"
                    class="boss-input pega-height-35"
                    data-test="input-email"
                    size="60"
                    placeholder="メールアドレス"
                  >
                  <button
                    :disabled="isAddButtonDisabled"
                    class="boss-button pega-button boss-button-center"
                    data-test="add-account"
                    @click="registerNotificationAccount"
                  >
                    追加
                  </button>
                </template>
              </dd>
              <dt class="boss-scout-send-left">
                メッセージ<br>
                <small>(2,000文字以内)</small>
              </dt>
              <dd class="boss-scout-send-right">
                <textarea
                  v-model="messageBody"
                  :class="{ 'is-invalid-input': isOverLengthBody }"
                  class="pega-send-message-edit"
                  data-test="message"
                />
                <span
                  v-if="isOverLengthBody"
                  style="margin: 0"
                  class="form-error is-visible"
                  data-test="max-error-message-body"
                >本文は2000文字以内で入力してください</span>
              </dd>
            </dl>
            <div class="boss-layout boss-layout-center">
              <button
                :disabled="isSendButtonDisabled"
                class="boss-button boss-button-confirm pega-button"
                data-test="send-button"
                @click="submit"
              >
                メッセージを送信する
              </button>
            </div>
          </div>
        </template>
      </accordion>
    </div>
    <div class="boss-layout-block-large">
      <accordion
        v-if="messages.length"
        :is-open="true"
      >
        <template #head>
          メッセージ履歴
        </template>
        <template #body>
          <job-edit-preview-message-sent
            v-if="messages.length"
            :messages="messages"
          />
        </template>
      </accordion>
    </div>
  </div>
</template>

<script>
import JobEditPreviewMessageSent from '@/components/molecules/JobEditPreviewMessageSent'
import Accordion from '@/components/atoms/Accordion'
import Indicator from '@/lib/indicator'
import _ from 'lodash'

export default {
  components: {
    Accordion,
    JobEditPreviewMessageSent
  },
  data () {
    return {
      jobId: '',
      isCompanyStaff: true,
      apiPath: '',
      notificationApiPath: '',
      name: '',
      email: '',
      messageBody: '',
      messages: [],
      recipient: {}
    }
  },
  computed: {
    isEmptyBody () {
      return this.messageBody.trim().length === 0
    },
    isOverLengthBody () {
      return this.messageBody.length > 2000
    },
    isNoSendUser () {
      return this.checkedCc.length === 0 && this.checkedTo.length === 0
    },
    isEmptyName () {
      return this.name.trim().length === 0
    },
    isEmptyEmail () {
      return this.email.trim().length === 0
    },
    isAddButtonDisabled () {
      return this.isEmptyName || this.isEmptyEmail
    },
    isSendButtonDisabled () {
      return this.isEmptyBody || this.isOverLengthBody ||
      this.isNoSendUser
    },
    checkedCc () {
      return this.recipient.cc.filter(sender => sender.checked)
    },
    checkedTo () {
      return this.recipient.to.filter(sender => sender.checked)
    },
    isNotificationUser (categoryId) {
      // CCリストでNotificationUser(categoryId=3)のみボタンを表示する
      return (categoryId) => { return categoryId === 3 }
    },
    isRecipientsEmpty () {
      return _.isEmpty(this.recipient)
    },
    isRecipientsCcEmpty () {
      return this.recipient.cc.length === 0
    }
  },
  created () {
    this.jobId = this.$route.params.jobId
    this.isCompanyStaff = (this.$route.name !== 'admPreview')
    // APIをADMとBOSSで分ける
    this.apiPath = this.isCompanyStaff
      ? `/preview/edit/jobs/${this.jobId}/`
      : `/preview/edit/companies/${this.$route.params.companyId}/jobs/${this.jobId}/`
    // ADMからのアクセス時のみ通知リスト用のAPIpath作成
    if (!this.isCompanyStaff) this.notificationApiPath = `/preview/edit/companies/${this.$route.params.companyId}/`
    this.fetchMessages()
    this.fetchRecipients()
  },
  methods: {
    fetchMessages () {
      this.$http.secured.get(this.apiPath + 'messages').then((messagesResponse) => {
        this.$set(this, 'messages', messagesResponse.data)
      })
    },
    fetchRecipients () {
      this.$http.secured.get(this.apiPath + 'recipients').then((response) => {
        this.$set(this, 'recipient', response.data)
      })
    },
    registerNotificationAccount () {
      const params = {
        name: this.name,
        email: this.email
      }
      Indicator.emitShow()
      this.$http.secured.post(this.notificationApiPath + 'notification_accounts', params).then(response => {
        this.$toasted.global.success({ message: 'CCに登録完了しました' })
        const newRecipient = {
          to: this.recipient.to,
          cc: [...this.recipient.cc, response.data]
        }
        this.$set(this, 'recipient', newRecipient)
        Indicator.emitHide()
        this.resetNewNotificationAccount()
      }).catch(() => {
        Indicator.emitHide()
      })
    },
    // 送信ボタン押下時
    submit () {
      // checkedされたID取得
      const messageSend = this.checkedTo.concat(this.checkedCc).map(recipient => ({
        category: recipient.categoryId,
        id: recipient.id
      }))
      // 送信先、新規ユーザー・メッセージ追加
      const requestForm = {
        body: this.messageBody,
        sendTo: messageSend
      }
      Indicator.emitShow()
      this.messageBody = ''
      this.$http.secured.post(this.apiPath + 'messages', requestForm).then(response => {
        this.fetchMessages()
        this.fetchRecipients()
        Indicator.emitHide()
        this.$toasted.global.success({ message: 'メッセージを送信しました。' })
      }).catch(() => {
        Indicator.emitHide()
      })
    },
    deleteNotificationAccount (id) {
      this.$dialog.confirm('メッセージの履歴からも削除されます。本当に削除しますか？')
        .then(() => {
          this.$http.secured.delete(this.notificationApiPath + `notification_accounts/${id}`).then(() => {
            this.$toasted.global.success({ message: '通知ユーザーを削除しました' })
            this.fetchRecipients()
          })
        }) // いいえを押下した時（catch句を消すとコンソールに警告が出るから消さないでね！！）
        .catch(() => {})
    },
    resetNewNotificationAccount () {
      this.$set(this, 'name', '')
      this.$set(this, 'email', '')
    }
  }
}
</script>
